import React from 'react';
import { Select as Se, FormControl, InputLabel } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const StyledSelect = withStyles({
	root: {
		marginLeft: '12px',
		'& .MuiInputBase-root': {
			background: 'rgb(41, 41, 41)',
			borderRadius: 3,
			border: '2px solid #e8c56a',
			color: '#e8c56a',
			padding: '13px'
		},
		'& .MuiInput-underline:before': {
			borderBottom: '0px solid rgba(0, 0, 0, 0)',
			borderBottomColor: 'rgba(0, 0, 0, 0)'
		},
		'& .MuiInput-underline:after': {
			borderBottom: '0px solid rgba(0, 0, 0, 0)',
			borderBottomColor: 'rgba(0, 0, 0, 0)'
		}
	}
})(FormControl);

const NeutralStyledSelect = withStyles({
	root: {
		background: 'rgba(60, 60, 60)',
		'& label': {
			color: 'white',
			paddingLeft: '12px'
		},
		'& label.MuiFormLabel-filled' : {
			color: 'white',
			padding: '12px 0 0 12px'
		},
		'& label.Mui-focused': {
			color: 'white',
			padding: '12px 0 0 12px'
		},
		'& .MuiSvgIcon-root': {
			color: 'white'
		},
		'& .MuiFormLabel-root.Mui-error': {
			color: 'lightgrey'
		},
		'& .MuiFilledInput-input': {
			padding: '35px 12px 12px',
			color: 'white',
			fontWeight: 'bold',
			fontSize: '13px'
		},
		'& .MuiInputAdornment-filled.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel)': {
			marginTop: '22px'
		},
		'& .MuiFilledInput-underline:before': {
			borderBottom: '3px solid rgba(40, 40, 40)',
			borderBottomColor: 'rgba(40, 40, 40)'
		},
		'& .MuiFilledInput-underline:after': {
			borderBottom: '3px solid rgba(40, 40, 40)',
			borderBottomColor: 'white'
		},
		'& .MuiFilledInput-underline.Mui-error:after': {
			borderBottom: '3px solid rgb(247, 12, 71)',
			borderBottomColor: 'rgb(247, 12, 71)'
		},
		'& .MuiFormLabel-asterisk.Mui-error': {
			color: 'white'
		}
	}
})(FormControl);

export function Select(props) {
	return <StyledSelect><Se {...props}>{props.children}</Se></StyledSelect>;
}

export function NeutralSelect(props) {
	return <NeutralStyledSelect fullWidth={props.fullWidth} required={props.required} className='mt-4'>
		<InputLabel>{props.placeholder}</InputLabel>
		<Se {...props}>{props.children}</Se>
	</NeutralStyledSelect>;
}
